import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://3g69hnqhsd.execute-api.eu-west-1.amazonaws.com/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

export const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getUser: () => api.get('/auth/user'),
  verify: (data) => api.post('/auth/verify', data),
  resendVerification: (data) => api.post('/auth/resend-verification', data),
  createChildAccount: (data) => api.post('/auth/child-account', data),
  updateName: (data) => api.put('/auth/update-name', data),
  updatePassword: (data) => api.put('/auth/update-password', data),
  updateChildName: (data) => api.put('/auth/child/update-name', data),
  deleteChildAccount: (childId) => api.delete(`/auth/child/${childId}`),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

export const groupService = {
  create: (data) => api.post('/groups/create', data),
  join: (data) => api.post('/groups/join', data),
};

export const wishlistService = {
  getMine: (childId) => api.get('/wishlists/mine', { params: childId ? { childId } : {} }),
  addItem: (data) => api.post('/wishlists/item', data),
  toggleShare: (isShared, childId) => api.put('/wishlists/share', { isShared, childId }),
  getFamily: () => api.get('/wishlists/family'),
  buyItem: (wishlistId, itemId, buyerId) => api.put(`/wishlists/buy/${wishlistId}/${itemId}`, buyerId ? { buyerId } : {}),
  unbuyItem: (wishlistId, itemId) => api.put(`/wishlists/unbuy/${wishlistId}/${itemId}`),
  deleteMemberWishlist: (userId) => api.delete(`/wishlists/member/${userId}`),
  deleteItem: (itemId, childId) => api.delete(`/wishlists/item/${itemId}`, { params: childId ? { childId } : {} }),
};

export default api;
